import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  onChangePage: PropTypes.func.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
};

export function UnstyledTablePaginationActions(props) {
  const { count, page, rowsPerPage, onChangePage } = props;

  function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  }

  function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  }

  function handlePageButtonClick(event, newPage) {
    onChangePage(event, newPage);
  }

  const selectedStyle = {
    borderRadius: '50%',
    backgroundColor: '#3C9BA0',
    color: 'white',
    outline: 'none',
  };

  return (
    <div style={{ margin: 'auto' }}>
      <button
        type="button"
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="Previous Page"
      >
        Previous
      </button>
      {[...Array(Math.ceil(count / rowsPerPage)).keys()].map((pageButton, index) => (
        <span
          role="button"
          tabIndex={index}
          key={pageButton}
          style={page === pageButton ? selectedStyle : {}}
          onClick={(event) => handlePageButtonClick(event, pageButton)}
          onKeyDown={(event) => handlePageButtonClick(event, pageButton)}
          value={pageButton}
        >
          {pageButton + 1}
        </span>
      ))}
      <button
        type="button"
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Next Page"
      >
        Next
      </button>
    </div>
  );
}

UnstyledTablePaginationActions.propTypes = propTypes;

export default UnstyledTablePaginationActions;
